/* sucrase/dist/esm/parser/plugins/flow.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.flowParseTypeParameterDeclaration = flowParseTypeParameterDeclaration;
    exports.flowParseTypeAnnotation = flowParseTypeAnnotation;
    exports.flowParseVariance = flowParseVariance;
    exports.flowParseFunctionBodyAndFinish = flowParseFunctionBodyAndFinish;
    exports.flowParseSubscript = flowParseSubscript;
    exports.flowStartParseNewArguments = flowStartParseNewArguments;
    exports.flowTryParseStatement = flowTryParseStatement;
    exports.flowTryParseExportDefaultExpression = flowTryParseExportDefaultExpression;
    exports.flowParseIdentifierStatement = flowParseIdentifierStatement;
    exports.flowShouldParseExportDeclaration = flowShouldParseExportDeclaration;
    exports.flowShouldDisallowExportDefaultSpecifier = flowShouldDisallowExportDefaultSpecifier;
    exports.flowParseExportDeclaration = flowParseExportDeclaration;
    exports.flowShouldParseExportStar = flowShouldParseExportStar;
    exports.flowParseExportStar = flowParseExportStar;
    exports.flowAfterParseClassSuper = flowAfterParseClassSuper;
    exports.flowStartParseObjPropValue = flowStartParseObjPropValue;
    exports.flowParseAssignableListItemTypes = flowParseAssignableListItemTypes;
    exports.flowStartParseImportSpecifiers = flowStartParseImportSpecifiers;
    exports.flowParseImportSpecifier = flowParseImportSpecifier;
    exports.flowStartParseFunctionParams = flowStartParseFunctionParams;
    exports.flowAfterParseVarHead = flowAfterParseVarHead;
    exports.flowStartParseAsyncArrowFromCallExpression = flowStartParseAsyncArrowFromCallExpression;
    exports.flowParseMaybeAssign = flowParseMaybeAssign;
    exports.flowParseArrow = flowParseArrow;
    exports.flowParseSubscripts = flowParseSubscripts;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const keywords_1 = require("99ff836c64") /* ../tokenizer/keywords */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const base_1 = require("540718e523") /* ../traverser/base */;
    const expression_1 = require("8178e7c3c8") /* ../traverser/expression */;
    const statement_1 = require("e3b9989da1") /* ../traverser/statement */;
    const util_1 = require("bc94bbadc1") /* ../traverser/util */;
    function isMaybeDefaultImport(lookahead) {
        return ((lookahead.type === types_1.TokenType.name || !!(lookahead.type & types_1.TokenType.IS_KEYWORD)) &&
            lookahead.contextualKeyword !== keywords_1.ContextualKeyword._from);
    }
    function flowParseTypeInitialiser(tok) {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(tok || types_1.TokenType.colon);
        flowParseType();
        (0, index_1.popTypeContext)(oldIsType);
    }
    function flowParsePredicate() {
        (0, util_1.expect)(types_1.TokenType.modulo);
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._checks);
        if ((0, index_1.eat)(types_1.TokenType.parenL)) {
            (0, expression_1.parseExpression)();
            (0, util_1.expect)(types_1.TokenType.parenR);
        }
    }
    function flowParseTypeAndPredicateInitialiser() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(types_1.TokenType.colon);
        if ((0, index_1.match)(types_1.TokenType.modulo)) {
            flowParsePredicate();
        }
        else {
            flowParseType();
            if ((0, index_1.match)(types_1.TokenType.modulo)) {
                flowParsePredicate();
            }
        }
        (0, index_1.popTypeContext)(oldIsType);
    }
    function flowParseDeclareClass() {
        (0, index_1.next)();
        flowParseInterfaceish(/* isClass */ true);
    }
    function flowParseDeclareFunction() {
        (0, index_1.next)();
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
        }
        (0, util_1.expect)(types_1.TokenType.parenL);
        flowParseFunctionTypeParams();
        (0, util_1.expect)(types_1.TokenType.parenR);
        flowParseTypeAndPredicateInitialiser();
        (0, util_1.semicolon)();
    }
    function flowParseDeclare() {
        if ((0, index_1.match)(types_1.TokenType._class)) {
            flowParseDeclareClass();
        }
        else if ((0, index_1.match)(types_1.TokenType._function)) {
            flowParseDeclareFunction();
        }
        else if ((0, index_1.match)(types_1.TokenType._var)) {
            flowParseDeclareVariable();
        }
        else if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._module)) {
            if ((0, index_1.eat)(types_1.TokenType.dot)) {
                flowParseDeclareModuleExports();
            }
            else {
                flowParseDeclareModule();
            }
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type)) {
            flowParseDeclareTypeAlias();
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._opaque)) {
            flowParseDeclareOpaqueType();
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._interface)) {
            flowParseDeclareInterface();
        }
        else if ((0, index_1.match)(types_1.TokenType._export)) {
            flowParseDeclareExportDeclaration();
        }
        else {
            (0, util_1.unexpected)();
        }
    }
    function flowParseDeclareVariable() {
        (0, index_1.next)();
        flowParseTypeAnnotatableIdentifier();
        (0, util_1.semicolon)();
    }
    function flowParseDeclareModule() {
        if ((0, index_1.match)(types_1.TokenType.string)) {
            (0, expression_1.parseExprAtom)();
        }
        else {
            (0, expression_1.parseIdentifier)();
        }
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, index_1.match)(types_1.TokenType.braceR) && !base_1.state.error) {
            if ((0, index_1.match)(types_1.TokenType._import)) {
                (0, index_1.next)();
                (0, statement_1.parseImport)();
            }
            else {
                (0, util_1.unexpected)();
            }
        }
        (0, util_1.expect)(types_1.TokenType.braceR);
    }
    function flowParseDeclareExportDeclaration() {
        (0, util_1.expect)(types_1.TokenType._export);
        if ((0, index_1.eat)(types_1.TokenType._default)) {
            if ((0, index_1.match)(types_1.TokenType._function) || (0, index_1.match)(types_1.TokenType._class)) {
                // declare export default class ...
                // declare export default function ...
                flowParseDeclare();
            }
            else {
                // declare export default [type];
                flowParseType();
                (0, util_1.semicolon)();
            }
        }
        else if ((0, index_1.match)(types_1.TokenType._var) || // declare export var ...
            (0, index_1.match)(types_1.TokenType._function) || // declare export function ...
            (0, index_1.match)(types_1.TokenType._class) || // declare export class ...
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._opaque) // declare export opaque ..
        ) {
            flowParseDeclare();
        }
        else if ((0, index_1.match)(types_1.TokenType.star) || // declare export * from ''
            (0, index_1.match)(types_1.TokenType.braceL) || // declare export {} ...
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._interface) || // declare export interface ...
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._type) || // declare export type ...
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._opaque) // declare export opaque type ...
        ) {
            (0, statement_1.parseExport)();
        }
        else {
            (0, util_1.unexpected)();
        }
    }
    function flowParseDeclareModuleExports() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._exports);
        flowParseTypeAnnotation();
        (0, util_1.semicolon)();
    }
    function flowParseDeclareTypeAlias() {
        (0, index_1.next)();
        flowParseTypeAlias();
    }
    function flowParseDeclareOpaqueType() {
        (0, index_1.next)();
        flowParseOpaqueType(true);
    }
    function flowParseDeclareInterface() {
        (0, index_1.next)();
        flowParseInterfaceish();
    }
    // Interfaces
    function flowParseInterfaceish(isClass = false) {
        flowParseRestrictedIdentifier();
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
        }
        if ((0, index_1.eat)(types_1.TokenType._extends)) {
            do {
                flowParseInterfaceExtends();
            } while (!isClass && (0, index_1.eat)(types_1.TokenType.comma));
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._mixins)) {
            (0, index_1.next)();
            do {
                flowParseInterfaceExtends();
            } while ((0, index_1.eat)(types_1.TokenType.comma));
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._implements)) {
            (0, index_1.next)();
            do {
                flowParseInterfaceExtends();
            } while ((0, index_1.eat)(types_1.TokenType.comma));
        }
        flowParseObjectType(isClass, false, isClass);
    }
    function flowParseInterfaceExtends() {
        flowParseQualifiedTypeIdentifier(false);
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterInstantiation();
        }
    }
    function flowParseInterface() {
        flowParseInterfaceish();
    }
    function flowParseRestrictedIdentifier() {
        (0, expression_1.parseIdentifier)();
    }
    function flowParseTypeAlias() {
        flowParseRestrictedIdentifier();
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
        }
        flowParseTypeInitialiser(types_1.TokenType.eq);
        (0, util_1.semicolon)();
    }
    function flowParseOpaqueType(declare) {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._type);
        flowParseRestrictedIdentifier();
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
        }
        // Parse the supertype
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            flowParseTypeInitialiser(types_1.TokenType.colon);
        }
        if (!declare) {
            flowParseTypeInitialiser(types_1.TokenType.eq);
        }
        (0, util_1.semicolon)();
    }
    function flowParseTypeParameter() {
        flowParseVariance();
        flowParseTypeAnnotatableIdentifier();
        if ((0, index_1.eat)(types_1.TokenType.eq)) {
            flowParseType();
        }
    }
    function flowParseTypeParameterDeclaration() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        // istanbul ignore else: this condition is already checked at all call sites
        if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.typeParameterStart)) {
            (0, index_1.next)();
        }
        else {
            (0, util_1.unexpected)();
        }
        do {
            flowParseTypeParameter();
            if (!(0, index_1.match)(types_1.TokenType.greaterThan)) {
                (0, util_1.expect)(types_1.TokenType.comma);
            }
        } while (!(0, index_1.match)(types_1.TokenType.greaterThan) && !base_1.state.error);
        (0, util_1.expect)(types_1.TokenType.greaterThan);
        (0, index_1.popTypeContext)(oldIsType);
    }
    function flowParseTypeParameterInstantiation() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, util_1.expect)(types_1.TokenType.lessThan);
        while (!(0, index_1.match)(types_1.TokenType.greaterThan) && !base_1.state.error) {
            flowParseType();
            if (!(0, index_1.match)(types_1.TokenType.greaterThan)) {
                (0, util_1.expect)(types_1.TokenType.comma);
            }
        }
        (0, util_1.expect)(types_1.TokenType.greaterThan);
        (0, index_1.popTypeContext)(oldIsType);
    }
    function flowParseInterfaceType() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._interface);
        if ((0, index_1.eat)(types_1.TokenType._extends)) {
            do {
                flowParseInterfaceExtends();
            } while ((0, index_1.eat)(types_1.TokenType.comma));
        }
        flowParseObjectType(false, false, false);
    }
    function flowParseObjectPropertyKey() {
        if ((0, index_1.match)(types_1.TokenType.num) || (0, index_1.match)(types_1.TokenType.string)) {
            (0, expression_1.parseExprAtom)();
        }
        else {
            (0, expression_1.parseIdentifier)();
        }
    }
    function flowParseObjectTypeIndexer() {
        // Note: bracketL has already been consumed
        if ((0, index_1.lookaheadType)() === types_1.TokenType.colon) {
            flowParseObjectPropertyKey();
            flowParseTypeInitialiser();
        }
        else {
            flowParseType();
        }
        (0, util_1.expect)(types_1.TokenType.bracketR);
        flowParseTypeInitialiser();
    }
    function flowParseObjectTypeInternalSlot() {
        // Note: both bracketL have already been consumed
        flowParseObjectPropertyKey();
        (0, util_1.expect)(types_1.TokenType.bracketR);
        (0, util_1.expect)(types_1.TokenType.bracketR);
        if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.parenL)) {
            flowParseObjectTypeMethodish();
        }
        else {
            (0, index_1.eat)(types_1.TokenType.question);
            flowParseTypeInitialiser();
        }
    }
    function flowParseObjectTypeMethodish() {
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
        }
        (0, util_1.expect)(types_1.TokenType.parenL);
        while (!(0, index_1.match)(types_1.TokenType.parenR) && !(0, index_1.match)(types_1.TokenType.ellipsis) && !base_1.state.error) {
            flowParseFunctionTypeParam();
            if (!(0, index_1.match)(types_1.TokenType.parenR)) {
                (0, util_1.expect)(types_1.TokenType.comma);
            }
        }
        if ((0, index_1.eat)(types_1.TokenType.ellipsis)) {
            flowParseFunctionTypeParam();
        }
        (0, util_1.expect)(types_1.TokenType.parenR);
        flowParseTypeInitialiser();
    }
    function flowParseObjectTypeCallProperty() {
        flowParseObjectTypeMethodish();
    }
    function flowParseObjectType(allowStatic, allowExact, allowProto) {
        let endDelim;
        if (allowExact && (0, index_1.match)(types_1.TokenType.braceBarL)) {
            (0, util_1.expect)(types_1.TokenType.braceBarL);
            endDelim = types_1.TokenType.braceBarR;
        }
        else {
            (0, util_1.expect)(types_1.TokenType.braceL);
            endDelim = types_1.TokenType.braceR;
        }
        while (!(0, index_1.match)(endDelim) && !base_1.state.error) {
            if (allowProto && (0, util_1.isContextual)(keywords_1.ContextualKeyword._proto)) {
                const lookahead = (0, index_1.lookaheadType)();
                if (lookahead !== types_1.TokenType.colon && lookahead !== types_1.TokenType.question) {
                    (0, index_1.next)();
                    allowStatic = false;
                }
            }
            if (allowStatic && (0, util_1.isContextual)(keywords_1.ContextualKeyword._static)) {
                const lookahead = (0, index_1.lookaheadType)();
                if (lookahead !== types_1.TokenType.colon && lookahead !== types_1.TokenType.question) {
                    (0, index_1.next)();
                }
            }
            flowParseVariance();
            if ((0, index_1.eat)(types_1.TokenType.bracketL)) {
                if ((0, index_1.eat)(types_1.TokenType.bracketL)) {
                    flowParseObjectTypeInternalSlot();
                }
                else {
                    flowParseObjectTypeIndexer();
                }
            }
            else if ((0, index_1.match)(types_1.TokenType.parenL) || (0, index_1.match)(types_1.TokenType.lessThan)) {
                flowParseObjectTypeCallProperty();
            }
            else {
                if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._get) || (0, util_1.isContextual)(keywords_1.ContextualKeyword._set)) {
                    const lookahead = (0, index_1.lookaheadType)();
                    if (lookahead === types_1.TokenType.name || lookahead === types_1.TokenType.string || lookahead === types_1.TokenType.num) {
                        (0, index_1.next)();
                    }
                }
                flowParseObjectTypeProperty();
            }
            flowObjectTypeSemicolon();
        }
        (0, util_1.expect)(endDelim);
    }
    function flowParseObjectTypeProperty() {
        if ((0, index_1.match)(types_1.TokenType.ellipsis)) {
            (0, util_1.expect)(types_1.TokenType.ellipsis);
            if (!(0, index_1.eat)(types_1.TokenType.comma)) {
                (0, index_1.eat)(types_1.TokenType.semi);
            }
            // Explicit inexact object syntax.
            if ((0, index_1.match)(types_1.TokenType.braceR)) {
                return;
            }
            flowParseType();
        }
        else {
            flowParseObjectPropertyKey();
            if ((0, index_1.match)(types_1.TokenType.lessThan) || (0, index_1.match)(types_1.TokenType.parenL)) {
                // This is a method property
                flowParseObjectTypeMethodish();
            }
            else {
                (0, index_1.eat)(types_1.TokenType.question);
                flowParseTypeInitialiser();
            }
        }
    }
    function flowObjectTypeSemicolon() {
        if (!(0, index_1.eat)(types_1.TokenType.semi) && !(0, index_1.eat)(types_1.TokenType.comma) && !(0, index_1.match)(types_1.TokenType.braceR) && !(0, index_1.match)(types_1.TokenType.braceBarR)) {
            (0, util_1.unexpected)();
        }
    }
    function flowParseQualifiedTypeIdentifier(initialIdAlreadyParsed) {
        if (!initialIdAlreadyParsed) {
            (0, expression_1.parseIdentifier)();
        }
        while ((0, index_1.eat)(types_1.TokenType.dot)) {
            (0, expression_1.parseIdentifier)();
        }
    }
    function flowParseGenericType() {
        flowParseQualifiedTypeIdentifier(true);
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterInstantiation();
        }
    }
    function flowParseTypeofType() {
        (0, util_1.expect)(types_1.TokenType._typeof);
        flowParsePrimaryType();
    }
    function flowParseTupleType() {
        (0, util_1.expect)(types_1.TokenType.bracketL);
        // We allow trailing commas
        while (base_1.state.pos < base_1.input.length && !(0, index_1.match)(types_1.TokenType.bracketR)) {
            flowParseType();
            if ((0, index_1.match)(types_1.TokenType.bracketR)) {
                break;
            }
            (0, util_1.expect)(types_1.TokenType.comma);
        }
        (0, util_1.expect)(types_1.TokenType.bracketR);
    }
    function flowParseFunctionTypeParam() {
        const lookahead = (0, index_1.lookaheadType)();
        if (lookahead === types_1.TokenType.colon || lookahead === types_1.TokenType.question) {
            (0, expression_1.parseIdentifier)();
            (0, index_1.eat)(types_1.TokenType.question);
            flowParseTypeInitialiser();
        }
        else {
            flowParseType();
        }
    }
    function flowParseFunctionTypeParams() {
        while (!(0, index_1.match)(types_1.TokenType.parenR) && !(0, index_1.match)(types_1.TokenType.ellipsis) && !base_1.state.error) {
            flowParseFunctionTypeParam();
            if (!(0, index_1.match)(types_1.TokenType.parenR)) {
                (0, util_1.expect)(types_1.TokenType.comma);
            }
        }
        if ((0, index_1.eat)(types_1.TokenType.ellipsis)) {
            flowParseFunctionTypeParam();
        }
    }
    // The parsing of types roughly parallels the parsing of expressions, and
    // primary types are kind of like primary expressions...they're the
    // primitives with which other types are constructed.
    function flowParsePrimaryType() {
        let isGroupedType = false;
        const oldNoAnonFunctionType = base_1.state.noAnonFunctionType;
        switch (base_1.state.type) {
            case types_1.TokenType.name: {
                if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._interface)) {
                    flowParseInterfaceType();
                    return;
                }
                (0, expression_1.parseIdentifier)();
                flowParseGenericType();
                return;
            }
            case types_1.TokenType.braceL:
                flowParseObjectType(false, false, false);
                return;
            case types_1.TokenType.braceBarL:
                flowParseObjectType(false, true, false);
                return;
            case types_1.TokenType.bracketL:
                flowParseTupleType();
                return;
            case types_1.TokenType.lessThan:
                flowParseTypeParameterDeclaration();
                (0, util_1.expect)(types_1.TokenType.parenL);
                flowParseFunctionTypeParams();
                (0, util_1.expect)(types_1.TokenType.parenR);
                (0, util_1.expect)(types_1.TokenType.arrow);
                flowParseType();
                return;
            case types_1.TokenType.parenL:
                (0, index_1.next)();
                // Check to see if this is actually a grouped type
                if (!(0, index_1.match)(types_1.TokenType.parenR) && !(0, index_1.match)(types_1.TokenType.ellipsis)) {
                    if ((0, index_1.match)(types_1.TokenType.name)) {
                        const token = (0, index_1.lookaheadType)();
                        isGroupedType = token !== types_1.TokenType.question && token !== types_1.TokenType.colon;
                    }
                    else {
                        isGroupedType = true;
                    }
                }
                if (isGroupedType) {
                    base_1.state.noAnonFunctionType = false;
                    flowParseType();
                    base_1.state.noAnonFunctionType = oldNoAnonFunctionType;
                    // A `,` or a `) =>` means this is an anonymous function type
                    if (base_1.state.noAnonFunctionType ||
                        !((0, index_1.match)(types_1.TokenType.comma) || ((0, index_1.match)(types_1.TokenType.parenR) && (0, index_1.lookaheadType)() === types_1.TokenType.arrow))) {
                        (0, util_1.expect)(types_1.TokenType.parenR);
                        return;
                    }
                    else {
                        // Eat a comma if there is one
                        (0, index_1.eat)(types_1.TokenType.comma);
                    }
                }
                flowParseFunctionTypeParams();
                (0, util_1.expect)(types_1.TokenType.parenR);
                (0, util_1.expect)(types_1.TokenType.arrow);
                flowParseType();
                return;
            case types_1.TokenType.minus:
                (0, index_1.next)();
                (0, expression_1.parseLiteral)();
                return;
            case types_1.TokenType.string:
            case types_1.TokenType.num:
            case types_1.TokenType._true:
            case types_1.TokenType._false:
            case types_1.TokenType._null:
            case types_1.TokenType._this:
            case types_1.TokenType._void:
            case types_1.TokenType.star:
                (0, index_1.next)();
                return;
            default:
                if (base_1.state.type === types_1.TokenType._typeof) {
                    flowParseTypeofType();
                    return;
                }
                else if (base_1.state.type & types_1.TokenType.IS_KEYWORD) {
                    (0, index_1.next)();
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType.name;
                    return;
                }
        }
        (0, util_1.unexpected)();
    }
    function flowParsePostfixType() {
        flowParsePrimaryType();
        while (!(0, util_1.canInsertSemicolon)() && ((0, index_1.match)(types_1.TokenType.bracketL) || (0, index_1.match)(types_1.TokenType.questionDot))) {
            (0, index_1.eat)(types_1.TokenType.questionDot);
            (0, util_1.expect)(types_1.TokenType.bracketL);
            if ((0, index_1.eat)(types_1.TokenType.bracketR)) {
                // Array type
            }
            else {
                // Indexed access type
                flowParseType();
                (0, util_1.expect)(types_1.TokenType.bracketR);
            }
        }
    }
    function flowParsePrefixType() {
        if ((0, index_1.eat)(types_1.TokenType.question)) {
            flowParsePrefixType();
        }
        else {
            flowParsePostfixType();
        }
    }
    function flowParseAnonFunctionWithoutParens() {
        flowParsePrefixType();
        if (!base_1.state.noAnonFunctionType && (0, index_1.eat)(types_1.TokenType.arrow)) {
            flowParseType();
        }
    }
    function flowParseIntersectionType() {
        (0, index_1.eat)(types_1.TokenType.bitwiseAND);
        flowParseAnonFunctionWithoutParens();
        while ((0, index_1.eat)(types_1.TokenType.bitwiseAND)) {
            flowParseAnonFunctionWithoutParens();
        }
    }
    function flowParseUnionType() {
        (0, index_1.eat)(types_1.TokenType.bitwiseOR);
        flowParseIntersectionType();
        while ((0, index_1.eat)(types_1.TokenType.bitwiseOR)) {
            flowParseIntersectionType();
        }
    }
    function flowParseType() {
        flowParseUnionType();
    }
    function flowParseTypeAnnotation() {
        flowParseTypeInitialiser();
    }
    function flowParseTypeAnnotatableIdentifier() {
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            flowParseTypeAnnotation();
        }
    }
    function flowParseVariance() {
        if ((0, index_1.match)(types_1.TokenType.plus) || (0, index_1.match)(types_1.TokenType.minus)) {
            (0, index_1.next)();
            base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
        }
    }
    // ==================================
    // Overrides
    // ==================================
    function flowParseFunctionBodyAndFinish(funcContextId) {
        // For arrow functions, `parseArrow` handles the return type itself.
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            flowParseTypeAndPredicateInitialiser();
        }
        (0, expression_1.parseFunctionBody)(false, funcContextId);
    }
    function flowParseSubscript(startTokenIndex, noCalls, stopState) {
        if ((0, index_1.match)(types_1.TokenType.questionDot) && (0, index_1.lookaheadType)() === types_1.TokenType.lessThan) {
            if (noCalls) {
                stopState.stop = true;
                return;
            }
            (0, index_1.next)();
            flowParseTypeParameterInstantiation();
            (0, util_1.expect)(types_1.TokenType.parenL);
            (0, expression_1.parseCallExpressionArguments)();
            return;
        }
        else if (!noCalls && (0, index_1.match)(types_1.TokenType.lessThan)) {
            const snapshot = base_1.state.snapshot();
            flowParseTypeParameterInstantiation();
            (0, util_1.expect)(types_1.TokenType.parenL);
            (0, expression_1.parseCallExpressionArguments)();
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
            else {
                return;
            }
        }
        (0, expression_1.baseParseSubscript)(startTokenIndex, noCalls, stopState);
    }
    function flowStartParseNewArguments() {
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            const snapshot = base_1.state.snapshot();
            flowParseTypeParameterInstantiation();
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
        }
    }
    // interfaces
    function flowTryParseStatement() {
        if ((0, index_1.match)(types_1.TokenType.name) && base_1.state.contextualKeyword === keywords_1.ContextualKeyword._interface) {
            const oldIsType = (0, index_1.pushTypeContext)(0);
            (0, index_1.next)();
            flowParseInterface();
            (0, index_1.popTypeContext)(oldIsType);
            return true;
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._enum)) {
            flowParseEnumDeclaration();
            return true;
        }
        return false;
    }
    function flowTryParseExportDefaultExpression() {
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._enum)) {
            flowParseEnumDeclaration();
            return true;
        }
        return false;
    }
    // declares, interfaces and type aliases
    function flowParseIdentifierStatement(contextualKeyword) {
        if (contextualKeyword === keywords_1.ContextualKeyword._declare) {
            if ((0, index_1.match)(types_1.TokenType._class) ||
                (0, index_1.match)(types_1.TokenType.name) ||
                (0, index_1.match)(types_1.TokenType._function) ||
                (0, index_1.match)(types_1.TokenType._var) ||
                (0, index_1.match)(types_1.TokenType._export)) {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                flowParseDeclare();
                (0, index_1.popTypeContext)(oldIsType);
            }
        }
        else if ((0, index_1.match)(types_1.TokenType.name)) {
            if (contextualKeyword === keywords_1.ContextualKeyword._interface) {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                flowParseInterface();
                (0, index_1.popTypeContext)(oldIsType);
            }
            else if (contextualKeyword === keywords_1.ContextualKeyword._type) {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                flowParseTypeAlias();
                (0, index_1.popTypeContext)(oldIsType);
            }
            else if (contextualKeyword === keywords_1.ContextualKeyword._opaque) {
                const oldIsType = (0, index_1.pushTypeContext)(1);
                flowParseOpaqueType(false);
                (0, index_1.popTypeContext)(oldIsType);
            }
        }
        (0, util_1.semicolon)();
    }
    // export type
    function flowShouldParseExportDeclaration() {
        return ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type) ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._interface) ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._opaque) ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._enum));
    }
    function flowShouldDisallowExportDefaultSpecifier() {
        return ((0, index_1.match)(types_1.TokenType.name) &&
            (base_1.state.contextualKeyword === keywords_1.ContextualKeyword._type ||
                base_1.state.contextualKeyword === keywords_1.ContextualKeyword._interface ||
                base_1.state.contextualKeyword === keywords_1.ContextualKeyword._opaque ||
                base_1.state.contextualKeyword === keywords_1.ContextualKeyword._enum));
    }
    function flowParseExportDeclaration() {
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type)) {
            const oldIsType = (0, index_1.pushTypeContext)(1);
            (0, index_1.next)();
            if ((0, index_1.match)(types_1.TokenType.braceL)) {
                // export type { foo, bar };
                (0, statement_1.parseExportSpecifiers)();
                (0, statement_1.parseExportFrom)();
            }
            else {
                // export type Foo = Bar;
                flowParseTypeAlias();
            }
            (0, index_1.popTypeContext)(oldIsType);
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._opaque)) {
            const oldIsType = (0, index_1.pushTypeContext)(1);
            (0, index_1.next)();
            // export opaque type Foo = Bar;
            flowParseOpaqueType(false);
            (0, index_1.popTypeContext)(oldIsType);
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._interface)) {
            const oldIsType = (0, index_1.pushTypeContext)(1);
            (0, index_1.next)();
            flowParseInterface();
            (0, index_1.popTypeContext)(oldIsType);
        }
        else {
            (0, statement_1.parseStatement)(true);
        }
    }
    function flowShouldParseExportStar() {
        return (0, index_1.match)(types_1.TokenType.star) || ((0, util_1.isContextual)(keywords_1.ContextualKeyword._type) && (0, index_1.lookaheadType)() === types_1.TokenType.star);
    }
    function flowParseExportStar() {
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._type)) {
            const oldIsType = (0, index_1.pushTypeContext)(2);
            (0, statement_1.baseParseExportStar)();
            (0, index_1.popTypeContext)(oldIsType);
        }
        else {
            (0, statement_1.baseParseExportStar)();
        }
    }
    // parse a the super class type parameters and implements
    function flowAfterParseClassSuper(hasSuper) {
        if (hasSuper && (0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterInstantiation();
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._implements)) {
            const oldIsType = (0, index_1.pushTypeContext)(0);
            (0, index_1.next)();
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._implements;
            do {
                flowParseRestrictedIdentifier();
                if ((0, index_1.match)(types_1.TokenType.lessThan)) {
                    flowParseTypeParameterInstantiation();
                }
            } while ((0, index_1.eat)(types_1.TokenType.comma));
            (0, index_1.popTypeContext)(oldIsType);
        }
    }
    // parse type parameters for object method shorthand
    function flowStartParseObjPropValue() {
        // method shorthand
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            flowParseTypeParameterDeclaration();
            if (!(0, index_1.match)(types_1.TokenType.parenL))
                (0, util_1.unexpected)();
        }
    }
    function flowParseAssignableListItemTypes() {
        const oldIsType = (0, index_1.pushTypeContext)(0);
        (0, index_1.eat)(types_1.TokenType.question);
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            flowParseTypeAnnotation();
        }
        (0, index_1.popTypeContext)(oldIsType);
    }
    // parse typeof and type imports
    function flowStartParseImportSpecifiers() {
        if ((0, index_1.match)(types_1.TokenType._typeof) || (0, util_1.isContextual)(keywords_1.ContextualKeyword._type)) {
            const lh = (0, index_1.lookaheadTypeAndKeyword)();
            if (isMaybeDefaultImport(lh) || lh.type === types_1.TokenType.braceL || lh.type === types_1.TokenType.star) {
                (0, index_1.next)();
            }
        }
    }
    // parse import-type/typeof shorthand
    function flowParseImportSpecifier() {
        const isTypeKeyword = base_1.state.contextualKeyword === keywords_1.ContextualKeyword._type || base_1.state.type === types_1.TokenType._typeof;
        if (isTypeKeyword) {
            (0, index_1.next)();
        }
        else {
            (0, expression_1.parseIdentifier)();
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._as) && !(0, util_1.isLookaheadContextual)(keywords_1.ContextualKeyword._as)) {
            (0, expression_1.parseIdentifier)();
            if (isTypeKeyword && !(0, index_1.match)(types_1.TokenType.name) && !(base_1.state.type & types_1.TokenType.IS_KEYWORD)) {
                // `import {type as ,` or `import {type as }`
            }
            else {
                // `import {type as foo`
                (0, expression_1.parseIdentifier)();
            }
        }
        else {
            if (isTypeKeyword && ((0, index_1.match)(types_1.TokenType.name) || !!(base_1.state.type & types_1.TokenType.IS_KEYWORD))) {
                // `import {type foo`
                (0, expression_1.parseIdentifier)();
            }
            if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._as)) {
                (0, expression_1.parseIdentifier)();
            }
        }
    }
    // parse function type parameters - function foo<T>() {}
    function flowStartParseFunctionParams() {
        // Originally this checked if the method is a getter/setter, but if it was, we'd crash soon
        // anyway, so don't try to propagate that information.
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            const oldIsType = (0, index_1.pushTypeContext)(0);
            flowParseTypeParameterDeclaration();
            (0, index_1.popTypeContext)(oldIsType);
        }
    }
    // parse flow type annotations on variable declarator heads - let foo: string = bar
    function flowAfterParseVarHead() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            flowParseTypeAnnotation();
        }
    }
    // parse the return type of an async arrow function - let foo = (async (): number => {});
    function flowStartParseAsyncArrowFromCallExpression() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            const oldNoAnonFunctionType = base_1.state.noAnonFunctionType;
            base_1.state.noAnonFunctionType = true;
            flowParseTypeAnnotation();
            base_1.state.noAnonFunctionType = oldNoAnonFunctionType;
        }
    }
    // We need to support type parameter declarations for arrow functions. This
    // is tricky. There are three situations we need to handle
    //
    // 1. This is either JSX or an arrow function. We'll try JSX first. If that
    //    fails, we'll try an arrow function. If that fails, we'll throw the JSX
    //    error.
    // 2. This is an arrow function. We'll parse the type parameter declaration,
    //    parse the rest, make sure the rest is an arrow function, and go from
    //    there
    // 3. This is neither. Just call the super method
    function flowParseMaybeAssign(noIn, isWithinParens) {
        if ((0, index_1.match)(types_1.TokenType.lessThan)) {
            const snapshot = base_1.state.snapshot();
            let wasArrow = (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
                base_1.state.type = types_1.TokenType.typeParameterStart;
            }
            else {
                return wasArrow;
            }
            const oldIsType = (0, index_1.pushTypeContext)(0);
            flowParseTypeParameterDeclaration();
            (0, index_1.popTypeContext)(oldIsType);
            wasArrow = (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
            if (wasArrow) {
                return true;
            }
            (0, util_1.unexpected)();
        }
        return (0, expression_1.baseParseMaybeAssign)(noIn, isWithinParens);
    }
    // handle return types for arrow functions
    function flowParseArrow() {
        if ((0, index_1.match)(types_1.TokenType.colon)) {
            const oldIsType = (0, index_1.pushTypeContext)(0);
            const snapshot = base_1.state.snapshot();
            const oldNoAnonFunctionType = base_1.state.noAnonFunctionType;
            base_1.state.noAnonFunctionType = true;
            flowParseTypeAndPredicateInitialiser();
            base_1.state.noAnonFunctionType = oldNoAnonFunctionType;
            if ((0, util_1.canInsertSemicolon)())
                (0, util_1.unexpected)();
            if (!(0, index_1.match)(types_1.TokenType.arrow))
                (0, util_1.unexpected)();
            if (base_1.state.error) {
                base_1.state.restoreFromSnapshot(snapshot);
            }
            (0, index_1.popTypeContext)(oldIsType);
        }
        return (0, index_1.eat)(types_1.TokenType.arrow);
    }
    function flowParseSubscripts(startTokenIndex, noCalls = false) {
        if (base_1.state.tokens[base_1.state.tokens.length - 1].contextualKeyword === keywords_1.ContextualKeyword._async &&
            (0, index_1.match)(types_1.TokenType.lessThan)) {
            const snapshot = base_1.state.snapshot();
            const wasArrow = parseAsyncArrowWithTypeParameters();
            if (wasArrow && !base_1.state.error) {
                return;
            }
            base_1.state.restoreFromSnapshot(snapshot);
        }
        (0, expression_1.baseParseSubscripts)(startTokenIndex, noCalls);
    }
    // Returns true if there was an arrow function here.
    function parseAsyncArrowWithTypeParameters() {
        base_1.state.scopeDepth++;
        const startTokenIndex = base_1.state.tokens.length;
        (0, statement_1.parseFunctionParams)();
        if (!(0, expression_1.parseArrow)()) {
            return false;
        }
        (0, expression_1.parseArrowExpression)(startTokenIndex);
        return true;
    }
    function flowParseEnumDeclaration() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._enum);
        base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._enum;
        (0, expression_1.parseIdentifier)();
        flowParseEnumBody();
    }
    function flowParseEnumBody() {
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._of)) {
            (0, index_1.next)();
        }
        (0, util_1.expect)(types_1.TokenType.braceL);
        flowParseEnumMembers();
        (0, util_1.expect)(types_1.TokenType.braceR);
    }
    function flowParseEnumMembers() {
        while (!(0, index_1.match)(types_1.TokenType.braceR) && !base_1.state.error) {
            if ((0, index_1.eat)(types_1.TokenType.ellipsis)) {
                break;
            }
            flowParseEnumMember();
            if (!(0, index_1.match)(types_1.TokenType.braceR)) {
                (0, util_1.expect)(types_1.TokenType.comma);
            }
        }
    }
    function flowParseEnumMember() {
        (0, expression_1.parseIdentifier)();
        if ((0, index_1.eat)(types_1.TokenType.eq)) {
            // Flow enum values are always just one token (a string, number, or boolean literal).
            (0, index_1.next)();
        }
    }
}
